import { success, failure } from 'utilities/actions'
import * as actions from './actions'
import type { ProgramEvent } from 'types'

export type State = {
  data: ProgramEvent[];
  errors: any[];
};

export type Action = any & {
  type: string;
};

export const initialState = {
  data: [],
  errors: []
} as const

const reducer = (state: State, action: Action) => {
// @ts-expect-error - TS2322 - Type '{ readonly data: readonly []; readonly errors: readonly []; }' is not assignable to type 'State'.
  if (state === undefined) { state = initialState }
  switch (action.type) {
    case success(actions.API_PROGRAM_EVENTS_INDEX):
      const { data } = action
      return {
        ...state,
        data
      }
    case failure(actions.API_PROGRAM_EVENTS_INDEX):
      return {
        ...state,
        errors: action.errors
      }
    default:
      return state
  }
}

export default reducer
